
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Download } from 'lucide-react';
import AddToHomeScreen from '@/components/AddToHomeScreen';

interface InstallAppStepProps {
  onContinue: () => void;
  onSkip: () => void;
}

const InstallAppStep: React.FC<InstallAppStepProps> = ({ onContinue, onSkip }) => {
  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-center">Installer l'application</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center space-y-4">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
          <Download className="w-8 h-8 text-blue-600" />
        </div>
        <p className="text-center">
          Pour une meilleure expérience, installez EasyDJ+ sur votre appareil.
        </p>
        
        {/* AddToHomeScreen component displays platform-specific instructions */}
        <div className="w-full">
          <AddToHomeScreen embedded={true} />
        </div>
        
        <div className="w-full pt-4">
          <Button 
            onClick={onContinue} 
            className="w-full h-12"
          >
            J'ai installé l'application
          </Button>
        </div>
      </CardContent>
      <CardFooter className="flex justify-center">
        <Button 
          variant="ghost" 
          onClick={onSkip}
          className="text-sm"
        >
          Passer cette étape
        </Button>
      </CardFooter>
    </Card>
  );
};

export default InstallAppStep;
